<div class="login-page">

  <!-- LEFT PANEL -->
  <div class="left-panel">
    <div class="left-content">
      <div class="brand">
        <img src="/assets/imagotipo.png" alt="BarBook" class="brand-logo" />
      </div>

      <div class="brand-tagline">
        <h1 class="tagline-title">
          Tus bares favoritos,<br />
          siempre a mano.
        </h1>
        <p class="tagline-sub">
          Busca, organiza y comparte los mejores lugares de cualquier ciudad.
        </p>
      </div>

      <div class="left-decoration">
        <div class="deco-circle deco-circle--1"></div>
        <div class="deco-circle deco-circle--2"></div>
        <div class="deco-circle deco-circle--3"></div>
      </div>
    </div>
  </div>

  <!-- RIGHT PANEL -->
  <div class="right-panel">
    <div class="right-panel-inner">

      <!-- Logo visible only on mobile -->
      <div class="mobile-brand">
        <img src="/assets/imagotipo.png" alt="BarBook" class="mobile-brand-logo" />
      </div>

      <div class="login-card">

      <div class="card-header">
        <h2 class="card-title">Bienvenido de nuevo</h2>
        <p class="card-subtitle">Inicia sesión para acceder a tu cuenta</p>
      </div>

      <form [formGroup]="form" (ngSubmit)="login()" class="login-form">

        <!-- Email -->
        <div class="field-group" [class.field-group--error]="emailInvalid">
          <label for="email" class="field-label">Correo electrónico</label>
          <div class="field-input-wrapper">
            <svg class="field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="4" width="20" height="16" rx="2"/>
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
            </svg>
            <input
              id="email"
              type="email"
              formControlName="email"
              class="field-input"
              placeholder="tu@email.com"
              autocomplete="email"
            />
          </div>
          <span class="field-error" *ngIf="emailInvalid">
            Introduce un correo electrónico válido
          </span>
        </div>

        <!-- Password -->
        <div class="field-group" [class.field-group--error]="passwordInvalid">
          <label for="password" class="field-label">Contraseña</label>
          <div class="field-input-wrapper">
            <svg class="field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <input
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              class="field-input"
              placeholder="Mínimo 6 caracteres"
              autocomplete="current-password"
            />
            <button
              type="button"
              class="toggle-visibility"
              (click)="showPassword = !showPassword"
              [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            >
              <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </button>
          </div>
          <span class="field-error" *ngIf="passwordInvalid">
            La contraseña debe tener al menos 6 caracteres
          </span>
        </div>

        <!-- Global error -->
        <div class="login-error" *ngIf="loginError">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <span>{{ loginError }}</span>
        </div>

        <!-- Submit button -->
        <button
          type="submit"
          class="btn-login"
          [class.btn-login--loading]="loading"
          [disabled]="loading"
        >
          <span *ngIf="!loading">Iniciar sesión</span>
          <span *ngIf="loading" class="spinner"></span>
        </button>

      </form>

      <!-- Divider -->
      <div class="divider">
        <span>o continúa con</span>
      </div>

      <!-- Social buttons -->
      <div class="social-buttons">

        <button class="btn-social btn-social--google" (click)="loginWithGoogle()" [disabled]="loading">
          <svg class="social-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          <span>Google</span>
        </button>

        <button class="btn-social btn-social--apple" (click)="loginWithApple()" [disabled]="loading">
          <svg class="social-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98l-.09.06c-.22.15-2.22 1.3-2.2 3.88.03 3.07 2.7 4.1 2.73 4.11l-.09.19zM13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
          </svg>
          <span>Apple</span>
        </button>

      </div>

      <!-- Footer links -->
      <div class="card-footer">
        <p class="footer-text">
          ¿No tienes cuenta?
          <a href="#" class="footer-link" (click)="$event.preventDefault()">Regístrate</a>
        </p>
      </div>

    </div>
    </div>
  </div>

</div>
